if (!customElements.get('lyma-featured-gallery')) {
  customElements.define('lyma-featured-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.featured-thumb');
        if (!button || button.closest('lyma-featured-gallery') !== this) return;
        const image = button.querySelector('img');
        const main = this.querySelector('.featured-main-img');
        if (!image || !main) return;
        const url = new URL(image.getAttribute('src'), document.baseURI);
        url.searchParams.set('width', '800');
        main.src = url.href;
        main.alt = image.alt;
        this.querySelectorAll('.featured-thumb').forEach((thumb) => {
          const active = thumb === button;
          thumb.classList.toggle('active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
